import { Trail } from './trail.interface';

export const SingleTracks: Trail[] = [
  {
    code: 'coati-1',
    name: 'Coatí 1',
    description: '',
    walk_up: {
      difficulty: 0,
      banned: false,
      description: ''
    },
    walk_down: {
      difficulty: 0,
      banned: false,
      description: ''
    },
    bike_up: {
      difficulty: 0,
      banned: false,
      description: ''
    },
    bike_down: {
      difficulty: 0,
      banned: false,
      description: ''
    }
  },
  {
    code: 'coati-2',
    name: 'Coatí 2',
    description: '',
    walk_up: {
      difficulty: 0,
      banned: false,
      description: ''
    },
    walk_down: {
      difficulty: 0,
      banned: false,
      description: ''
    },
    bike_up: {
      difficulty: 0,
      banned: false,
      description: ''
    },
    bike_down: {
      difficulty: 0,
      banned: false,
      description: ''
    }
  },
  {
    code: 'coati-3',
    name: 'Coatí 3',
    description: 'Es la vereda más reciente, aún no tiene nombre oficial. Es muy angosta y con acantilados pronunciados.',
    walk_up: {
      difficulty: 2,
      banned: false,
      description: ''
    },
    walk_down: {
      difficulty: 2,
      banned: false,
      description: ''
    },
    bike_up: {
      difficulty: 4,
      banned: false,
      description: ''
    },
    bike_down: {
      difficulty: 3,
      banned: false,
      description: 'No es una bajada muy técnica, pero hay muchos segmentos muy angostos.'
    }
  },
  {
    code: 'coneja',
    name: 'Coneja',
    description: 'Camino de servicio exclusivo para guardabosques.',
    walk_up: {
      difficulty: 0,
      banned: true,
      description: ''
    },
    walk_down: {
      difficulty: 0,
      banned: true,
      description: ''
    },
    bike_up: {
      difficulty: 5,
      banned: true,
      description: ''
    },
    bike_down: {
      difficulty: 4,
      banned: true,
      description: ''
    }
  },
  {
    code: 'vereda-3',
    name: 'Vereda 3',
    description: '',
    walk_up: {
      difficulty: 0,
      banned: false,
      description: ''
    },
    walk_down: {
      difficulty: 0,
      banned: false,
      description: ''
    },
    bike_up: {
      difficulty: 5,
      banned: true,
      description: ''
    },
    bike_down: {
      difficulty: 4,
      banned: true,
      description: ''
    }
  },
  {
    code: 'florida',
    name: 'La Florida',
    description: '',
    walk_up: {
      difficulty: 4,
      banned: false,
      description: ''
    },
    walk_down: {
      difficulty: 4,
      banned: false,
      description: ''
    },
    bike_up: {
      difficulty: 5,
      banned: true,
      description: ''
    },
    bike_down: {
      difficulty: 5,
      banned: true,
      description: ''
    }
  },
  {
    code: 'piedra',
    name: 'Piedra',
    description: '',
    walk_up: {
      difficulty: 0,
      banned: false,
      description: ''
    },
    walk_down: {
      difficulty: 0,
      banned: false,
      description: ''
    },
    bike_up: {
      difficulty: 5,
      banned: false,
      description: ''
    },
    bike_down: {
      difficulty: 4,
      banned: false,
      description: ''
    }
  },
  {
    code: 'damian',
    name: 'Damián',
    description: '',
    walk_up: {
      difficulty: 0,
      banned: false,
      description: ''
    },
    walk_down: {
      difficulty: 0,
      banned: false,
      description: ''
    },
    bike_up: {
      difficulty: 0,
      banned: false,
      description: ''
    },
    bike_down: {
      difficulty: 0,
      banned: false,
      description: ''
    }
  },
  {
    code: 'casa-general',
    name: 'Casa del Gral. Almazán',
    description: '',
    walk_up: {
      difficulty: 0,
      banned: false,
      description: ''
    },
    walk_down: {
      difficulty: 0,
      banned: false,
      description: ''
    },
    bike_up: {
      difficulty: 2,
      banned: false,
      description: ''
    },
    bike_down: {
      difficulty: 2,
      banned: false,
      description: ''
    }
  },
  {
    code: 'tubo-enterrado',
    name: 'Tubo Enterrado',
    description: 'Es un camino muy angosto, generalmente húmedo y resbaloso.',
    walk_up: {
      difficulty: 0,
      banned: false,
      description: ''
    },
    walk_down: {
      difficulty: 0,
      banned: false,
      description: ''
    },
    bike_up: {
      difficulty: 3,
      banned: false,
      description: ''
    },
    bike_down: {
      difficulty: 3,
      banned: false,
      description: ''
    }
  },
  {
    code: 'tono-1',
    name: 'Don Toño 1',
    description: '',
    walk_up: {
      difficulty: 0,
      banned: false,
      description: ''
    },
    walk_down: {
      difficulty: 0,
      banned: false,
      description: ''
    },
    bike_up: {
      difficulty: 0,
      banned: false,
      description: ''
    },
    bike_down: {
      difficulty: 3,
      banned: false,
      description: ''
    }
  },
  {
    code: 'tono-2',
    name: 'Don Toño 2',
    description: '',
    walk_up: {
      difficulty: 0,
      banned: false,
      description: ''
    },
    walk_down: {
      difficulty: 0,
      banned: false,
      description: ''
    },
    bike_up: {
      difficulty: 0,
      banned: false,
      description: ''
    },
    bike_down: {
      difficulty: 4,
      banned: false,
      description: ''
    }
  },
  {
    code: 'tono-3',
    name: 'Don Toño 3',
    description: '',
    walk_up: {
      difficulty: 0,
      banned: false,
      description: ''
    },
    walk_down: {
      difficulty: 0,
      banned: false,
      description: ''
    },
    bike_up: {
      difficulty: 0,
      banned: false,
      description: ''
    },
    bike_down: {
      difficulty: 4,
      banned: false,
      description: ''
    }
  },
  {
    code: 'mina',
    name: 'Mina de San Francisco',
    description: '',
    walk_up: {
      difficulty: 0,
      banned: false,
      description: ''
    },
    walk_down: {
      difficulty: 0,
      banned: false,
      description: ''
    },
    bike_up: {
      difficulty: 0,
      banned: false,
      description: ''
    },
    bike_down: {
      difficulty: 0,
      banned: false,
      description: ''
    }
  },
  {
    code: 'abrazo-oso',
    name: 'Abrazo del Oso',
    description: '',
    walk_up: {
      difficulty: 0,
      banned: false,
      description: ''
    },
    walk_down: {
      difficulty: 0,
      banned: false,
      description: ''
    },
    bike_up: {
      difficulty: 0,
      banned: false,
      description: 'Partiendo del Empalme hacia el Pinal'
    },
    bike_down: {
      difficulty: 0,
      banned: false,
      description: 'Partiendo del Pinal hacia el Empalme'
    }
  },
  {
    code: 'cabras-1',
    name: 'Cabras 1',
    description: '',
    walk_up: {
      difficulty: 0,
      banned: false,
      description: ''
    },
    walk_down: {
      difficulty: 0,
      banned: false,
      description: ''
    },
    bike_up: {
      difficulty: 5,
      banned: true,
      description: ''
    },
    bike_down: {
      difficulty: 4,
      banned: true,
      description: ''
    }
  },
  {
    code: 'cabras-2',
    name: 'Cabras 2',
    description: '',
    walk_up: {
      difficulty: 0,
      banned: false,
      description: ''
    },
    walk_down: {
      difficulty: 0,
      banned: false,
      description: ''
    },
    bike_up: {
      difficulty: 5,
      banned: true,
      description: ''
    },
    bike_down: {
      difficulty: 4,
      banned: true,
      description: ''
    }
  },
  {
    code: 'zig-zag',
    name: 'Zig Zag',
    description: '',
    walk_up: {
      difficulty: 0,
      banned: false,
      description: ''
    },
    walk_down: {
      difficulty: 0,
      banned: false,
      description: ''
    },
    bike_up: {
      difficulty: 0,
      banned: false,
      description: ''
    },
    bike_down: {
      difficulty: 0,
      banned: true,
      description: ''
    }
  },
  {
    code: 'mela',
    name: 'Mela',
    description: '',
    walk_up: {
      difficulty: 0,
      banned: false,
      description: ''
    },
    walk_down: {
      difficulty: 0,
      banned: false,
      description: ''
    },
    bike_up: {
      difficulty: 0,
      banned: false,
      description: ''
    },
    bike_down: {
      difficulty: 0,
      banned: false,
      description: ''
    }
  },
  {
    code: 'federal',
    name: 'Federal',
    description: 'Cerrada por mantenimiento y cuidarla de la erosión',
    walk_up: {
      difficulty: 0,
      banned: true,
      description: ''
    },
    walk_down: {
      difficulty: 0,
      banned: true,
      description: ''
    },
    bike_up: {
      difficulty: 0,
      banned: true,
      description: ''
    },
    bike_down: {
      difficulty: 0,
      banned: true,
      description: ''
    }
  },
  {
    code: 'aranas',
    name: 'Arañas',
    description: '',
    walk_up: {
      difficulty: 0,
      banned: false,
      description: ''
    },
    walk_down: {
      difficulty: 0,
      banned: false,
      description: ''
    },
    bike_up: {
      difficulty: 0,
      banned: false,
      description: ''
    },
    bike_down: {
      difficulty: 4,
      banned: true,
      description: ''
    }
  },
  {
    code: 'ecobikes-rush',
    name: 'Ecobikes DH Rush',
    description: 'Pista privada de Downhill dentro de la propiedad del Hotel, operada por Ecobikes.',
    walk_up: {
      difficulty: 5,
      banned: true,
      description: ''
    },
    walk_down: {
      difficulty: 5,
      banned: true,
      description: ''
    },
    bike_up: {
      difficulty: 5,
      banned: true,
      description: ''
    },
    bike_down: {
      difficulty: 4,
      banned: false,
      description: ''
    }
  }
];



// WEBPACK FOOTER //
// /Users/mundofr/GitHub/Angle/ChipinqueTrails/src/app/singletracks.data.ts